<template>
  <div class="resume-body custom-resume-body">
    <div class="border">
      【個人資料蒐集、處理及利用告知事項】<br />
      為保護台端權益，請詳閱以下告知事項，台端於下表提供個人資料並簽名即表示已理解並同意以下規定：
      本公司基於招募聘用、
      人事管理、業務執行及相關營運需要之目的(下合稱「特定目的」)有必要於所在地
      以紙本、電子文件、電磁紀錄或其他合於當時
      科學技術之適當方式，在符合個人資料保護相關法令之範圍
      內，蒐集、於國內與國際間處理與利用台端於下表即未來所提供之個
      人資料(下稱「個人資料」)，並得於
      特定目的消失後保存至少15年。台端個人資料利用對象包括本公司及本公司國內外關係企業
      (下稱「本公
      司關係企業」)、本公司及本公司關係企業之職工福利委員會、財團法人日月之光慈善事業基金會、財團法
      人日月光
      文教基金會、以上公司、關係企業及組織之職員、代理人、專業顧問、及其所委託之第三人以及
      依法令得提供其台端個人資料之
      人。台端得依個人資料保護法第三條行使之相關權利包括(1)查詢或請求閱
      覽(2)請求製給複製本(3)請求補充或更正(4)請求停止蒐
      集、處理或利用(5)請求刪除。台端得自由選擇是
      否提供相關個人資料，台端若拒絕提供相關個人資料或未確實完整填寫，本公司
      可能無法進行相關審核及 處理作業而影響台端支應徵或任職機會。
      <div style="text-align: right">
        簽名：___________________ 民國____年____月____日
      </div>
    </div>

    <div class="border">
      <div class="border-bottom">
        1.錄取後可上班時間:{{
          idlResume.WorkedInfo.AvailableOnBoardDateOption
            ? idlResume.WorkedInfo.AvailableOnBoardDateOption
            : "無"
        }}
      </div>

      <div class="border-bottom">
        2.是否收到日月光主動邀約:
        <template v-if="typeof idlResume.WorkedInfo.IsInvited === 'boolean'">
          {{ idlResume.WorkedInfo.IsInvited ? "是" : "否" }}
        </template>
        <template v-else>無</template>
      </div>
      <div class="border-bottom">
        3.*曾至本公司應徵工作?
        <template v-if="typeof idlResume.WorkedInfo.HasAppliedCompany === 'boolean'">
          {{ idlResume.WorkedInfo.HasAppliedCompany ? "是" : "否" }}
        </template>
        <template v-else>無</template>
      </div>
      <div class="border-bottom">
        4.是否曾任職於本公司:
        <template v-if="typeof idlResume.WorkedInfo.HasWorkedInCompany === 'boolean'">
          {{ idlResume.WorkedInfo.HasWorkedInCompany ? "是" : "否" }}
        </template>
        <template v-else>無</template>
      </div>
      <div>
        5.招募管道來源:
        <template v-if="idlResume.WorkedInfo.RecruitmentSource">
          {{ idlResume.WorkedInfo.RecruitmentSource
          }}{{ idlResume.WorkedInfo.RecruitmentSourceDescActivityShool
          }}{{ idlResume.WorkedInfo.RecruitmentSourceDescActivityOrg
          }}{{ idlResume.WorkedInfo.RecruitmentSourceDescActivityOther
          }}{{ idlResume.WorkedInfo.RecruitmentSourceDescCenterOther
          }}{{ idlResume.WorkedInfo.RecruitmentSourceDescFlyerOther
          }}{{ idlResume.WorkedInfo.RecruitmentSourceDescJobBankOther
          }}{{ idlResume.WorkedInfo.RecruitmentSourceDescHunter
          }}{{ idlResume.WorkedInfo.RecruitmentSourceDescOtherSource }}
        </template>
        <template v-else>無</template>
      </div>
    </div>

    一、個人資料

    <table>
      <tr>
        <th id="name">中文姓名</th>
        <td>{{ name }}</td>
        <td>英文姓名</td>
        <td>
          {{ idlResume.BaseInfo.EnglishName ? idlResume.BaseInfo.EnglishName : "無" }}
        </td>
        <td>性別</td>
        <td>{{ idlResume.BaseInfo.Sex }}</td>

        <td colspan="2" rowspan="3" class="center-text">
          <img
            style="width: 125px; height: 125px; object-fit: cover"
            :src="headPhotoBase64 ? headPhotoBase64 : require(`@/assets/img/head2.png`)"
            alt=""
          />
        </td>
      </tr>
      <tr>
        <td>國籍</td>
        <td>{{ idlResume.BaseInfo.Nationality }}</td>
        <td>外籍在台原因</td>
        <td>
          {{
            idlResume.BaseInfo.ForeignerReason ? idlResume.BaseInfo.ForeignerReason : "無"
          }}
          {{
            idlResume.BaseInfo.ForeignerReasonDesc
              ? "-" + idlResume.BaseInfo.ForeignerReasonDesc
              : null
          }}
        </td>

        <td>身分證字號/護照號碼</td>
        <td>{{ idlResume.BaseInfo.IdNo }}</td>
      </tr>

      <tr>
        <td>生日</td>
        <td>{{ $common.dateFormatter(idlResume.BaseInfo.BirthDay) }}</td>
        <td>個人手機</td>
        <td>{{ idlResume.BaseInfo.MobilePhone }}</td>
        <td>家用電話(區域碼-號碼)</td>
        <td>{{ idlResume.BaseInfo.Phone ? idlResume.BaseInfo.Phone : "無" }}</td>
      </tr>

      <tr>
        <td>是否有身心障礙手冊</td>
        <td>
          {{ idlResume.BaseInfo.HasDisabilityCard ? "是" : "否" }}<br />
          {{
            idlResume.BaseInfo.HasDisabilityCardDesc
              ? "：" + idlResume.BaseInfo.HasDisabilityCardDesc
              : null
          }}
        </td>
        <td>說明</td>
        <td>
          {{ idlResume.BaseInfo.HasDisabilityCardDesc }}
        </td>
        <td>身高</td>
        <td>{{ idlResume.BaseInfo.Height ? idlResume.BaseInfo.Height + "cm" : "無" }}</td>
        <td style="width: 50px;">體重</td>
        <td style="width: 65px;">
          {{ idlResume.BaseInfo.Weight ? idlResume.BaseInfo.Weight + "kg" : "無" }}
        </td>
      </tr>
      <tr>
        <td>視力</td>
        <td>
          {{ idlResume.BaseInfo.VisualAcuity
          }}{{
            idlResume.BaseInfo.VisualAcuityDesc
              ? "，說明：" + idlResume.BaseInfo.VisualAcuityDesc
              : null
          }}
        </td>
        <td colspan="2">
          <span>左眼度數：{{ idlResume.BaseInfo.SPHLeft }}</span>
          <span>、右眼度數：{{ idlResume.BaseInfo.SPHRight }}</span>
        </td>
        <td>是否有散光</td>
        <td>{{ idlResume.BaseInfo.HasAstigmatic ? "是" : "否" }}</td>
        <td colspan="2">
          <span>左眼度數：{{ idlResume.BaseInfo.CYLLeft }}</span
          >、<span>右眼度數：{{ idlResume.BaseInfo.CYLRight }}</span>
        </td>
      </tr>
      <tr>
        <td>住處</td>
        <td>{{ idlResume.BaseInfo.ResidenceType }}</td>
        <td>出勤方式</td>
        <td>{{ idlResume.BaseInfo.CommutingType }}</td>
        <td>通勤時間</td>
        <td colspan="3">{{ idlResume.BaseInfo.CommutingMinutes }}分鐘</td>
      </tr>
      <tr>
        <td>通訊地址</td>
        <td colspan="7">
          {{ idlResume.BaseInfo.ContactCounty }}{{ idlResume.BaseInfo.ContactDistrict }}
          {{ idlResume.BaseInfo.ContactVillage }}{{ idlResume.BaseInfo.ContactAddress }}
        </td>
      </tr>
      <tr>
        <td>戶籍地址</td>
        <td colspan="7">
          {{ idlResume.BaseInfo.County }}{{ idlResume.BaseInfo.District }}
          {{ idlResume.BaseInfo.Village }}{{ idlResume.BaseInfo.Address }}
        </td>
      </tr>
      <tr>
        <td>Email</td>
        <td colspan="7">
          {{ idlResume.BaseInfo.Email }}
        </td>
      </tr>

      <tr>
        <td>緊急聯絡人姓名</td>
        <td colspan="2">{{ idlResume.BaseInfo.EmergencyContact }}</td>
        <td>緊急聯絡人關係</td>
        <td colspan="2">{{ idlResume.BaseInfo.EmergencyContactRelationship }}</td>
        <td>緊急聯絡人電話(手機)</td>
        <td colspan="3">{{ idlResume.BaseInfo.EmergencyContactPhone }}</td>
      </tr>

      <tr>
        <td>緊急聯絡人地址</td>
        <td colspan="6">
          {{ idlResume.BaseInfo.EmergencyContactCounty
          }}{{ idlResume.BaseInfo.EmergencyContactDistrict }}
          {{ idlResume.BaseInfo.EmergencyContactVillage
          }}{{ idlResume.BaseInfo.EmergencyContactAddress }}
        </td>
      </tr>
    </table>

    二、學歷

    <table>
      <tr>
        <th id="no">No.</th>
        <td>學校</td>
        <td>學歷</td>
        <td>科系名稱</td>
        <td>日校/夜校</td>
        <td>入學日期</td>
        <td>離校日期</td>
        <td>是否畢業</td>
      </tr>
      <tr v-for="(education, index) in idlResume.Educations" :key="education.Id">
        <td>{{ index + 1 }}</td>
        <td>
          {{
            education.SchoolGuid === "11111111-1111-1111-1111-111111111111"
              ? education.SchoolDescription
              : education.School
          }}
        </td>
        <td>{{ education.EducationCategory }}</td>
        <td>{{ education.MajorName ? education.MajorName : "無" }}</td>
        <td>{{ education.IsDaySchool ? "日校" : "夜校" }}</td>
        <td>{{ $common.monthFormatter(education.EducationFrom) }}</td>
        <td>
          {{
            education.EducationTo ? $common.monthFormatter(education.EducationTo) : "無"
          }}
        </td>
        <td>{{ education.IsGraduate ? "是" : "否" }}</td>
      </tr>
      <tr>
        <td colspan="2">短期內是否有繼續升學或進修的計畫</td>
        <td>{{ idlResume.BaseInfo.InSchoolOrHasStudyPlan ? "是" : "否" }}</td>
        <td>請詳述計畫內容</td>
        <td colspan="4">{{ idlResume.BaseInfo.InSchoolOrHasStudyPlanDesc }}</td>
      </tr>
    </table>

    三、工作經歷
    <table class="experience-table">
      <tr>
        <th id="no">No.</th>
        <td class="width-5">年資</td>
        <td class="width-10">工作期間</td>
        <td class="width-10">薪資</td>
        <td class="width-15">公司/產業</td>
        <td class="width-10">職稱</td>
        <td>主要工作內容</td>
        <td class="width-10">在職與否/(欲)離職原因</td>
      </tr>
      <tr
        v-for="(experience, index) in idlResume.WorkExperiences.WorkExperiences"
        :key="experience.Id"
      >
        <td>{{ index + 1 }}</td>
        <td>{{ experience.Seniority ? experience.Seniority : "無" }}年</td>
        <td>
          {{ $common.monthFormatter(experience.ExperienceFrom) }}~{{
            experience.ExperienceTo ? $common.monthFormatter(experience.ExperienceTo) : ""
          }}
        </td>
        <td>
          底薪:{{
            experience.BasicSalary
              ? $common.currencyThousands(String(experience.BasicSalary))
              : "無"
          }}<br />
          固定津貼:
          {{
            experience.FixedAllowance
              ? $common.currencyThousands(String(experience.FixedAllowance))
              : "無"
          }}<br />
          變動獎金:{{
            experience.VaryingBonus
              ? $common.currencyThousands(String(experience.VaryingBonus))
              : "無"
          }}<br />
          年薪:
          {{
            experience.YearlySalary
              ? $common.currencyThousands(String(experience.YearlySalary))
              : "無"
          }}
        </td>
        <td>
          產業:{{ experience.IndustryCategory }}<br />
          公司名稱:{{ experience.Company }}<br />
          工作地點:{{ experience.WorkCounty ? experience.WorkCounty : "無" }}/{{
            experience.WorkDistrict ? experience.WorkDistrict : "無"
          }}
        </td>
        <td>
          {{ experience.Position }}
        </td>
        <td class="work-content-wrap">
          <span v-if="experience.WorkContent" v-html="experience.WorkContent"></span>
          <span v-else>無</span>
        </td>
        <td>
          {{ experience.OnTheJob ? "是" : "否" }}<br />
          離職原因: {{ experience.LeaveReason }}
        </td>
      </tr>
      <tr>
        <td>合計年資</td>
        <td>{{ totalSeniority }}年</td>
        <td>期望全薪</td>
        <td colspan="2">
          {{
            idlResume.BaseInfo.ExpectedMonthlySalary
              ? $common.currencyThousands(
                  String(idlResume.BaseInfo.ExpectedMonthlySalary)
                )
              : "無"
          }}
        </td>
        <td>期望年薪</td>
        <td colspan="2">
          {{
            idlResume.BaseInfo.ExpectedYearlySalary
              ? $common.currencyThousands(String(idlResume.BaseInfo.ExpectedYearlySalary))
              : "無"
          }}
        </td>
      </tr>
    </table>

    四、保密義務
    <table>
      <tr>
        <th id="nda" colspan="4">
          本人是否對其他公司負有保密義務?<br />
          註：「保密義務」是指您對於前雇主的機密資訊負有保密責任，離職之後不得繼續使用、揭露或持有。
        </th>
        <td colspan="4">
        <span v-if="idlResume.NDA.HasNDA">是</span>
        <span v-else-if="idlResume.NDA.HasNDA === null">應聘者尚未填寫</span>
        <span v-else>對其他公司不負有保密義務</span>
        </td>
      </tr>
      <tr v-for="(nda, index) in idlResume.NDA.Details" :key="index">
        <td>所負義務對象</td>
        <td>{{ nda.Company }}</td>
        <td>保密義務內容</td>
        <td>{{ nda.Content }}</td>
        <td>是否永久</td>
        <td>{{ nda.IsPermanent ? "是" : "否" }}</td>
        <td>保密義務期間（起-迄）</td>
        <td>
          {{ $common.dateFormatter(nda.StartDate) }}~{{
            $common.dateFormatter(nda.EndDate)
          }}
        </td>
      </tr>
    </table>

    五、競業禁止
    <table>
      <tr>
        <th id="ncc" colspan="4">
          本人是否與其他公司簽訂競業禁止條款 ?<br />
          註：「保密義務」是指您對於前雇主的機密資訊負有保密責任，離職之後不得繼續使用、揭露或持有。
        </th>
        <td colspan="4">
          <span v-if="idlResume.NCC.HasNCC">是</span>
          <span v-else-if="idlResume.NCC.HasNCC === null">應聘者尚未填寫</span>
          <span v-else>未與其他公司簽訂競業禁止條款</span>
        </td>
      </tr>
      <template v-if="idlResume.NCC.HasNCC">
        <template v-for="(ncc,index) in idlResume.NCC.Details">
          <tr :key="index">
            <td>所負義務對象</td>
            <td>{{ ncc.Company }}</td>
            <td>競業禁止合約檔案</td>
            <td>
              <div v-for="file in ncc.ContractFiles" :key="file.FileGuid">
                <span
                  style="color: blue; cursor: pointer; text-decoration: underline"
                  @click="
                    $common.downloadFile({
                      fileGuid: file.FileGuid,
                      fileType: file.FileContentType,
                    })
                  "
                >
                  {{ file.FileName }} </span
                ><br />
              </div>
            </td>
            <td>競業禁止區域</td>
            <td>{{ ncc.District }}</td>
            <td>競業禁止範圍</td>
            <td>{{ ncc.Scope }}</td>
          </tr>

          <tr :key="'e'+index">
            <td>競業禁止期間（起-迄）</td>
            <td>
              {{ $common.dateFormatter(ncc.StartDate) }}~{{
                $common.dateFormatter(ncc.EndDate)
              }}
            </td>
            <td>備註事項</td>
            <td colspan="5">
              {{ ncc.Remark }}
            </td>
          </tr>
        </template>
      </template>
    </table>

    六、智財
    <table>
      <tr>
        <th id="ip" colspan="2">是否有取得或正在申請中之智財?（專利、商標、著作權或其他）</th>
        <td>
          <span v-if="idlResume.IP.HasIP">是</span>
          <span v-else-if="idlResume.IP.HasIP === null">應聘者尚未填寫</span>
          <span v-else>尚未擁有智財</span>
        </td>
      </tr>
      <tr>
        <td>IP code</td>
        <td>類型</td>
        <td class="width-60">說明</td>
      </tr>

      <template v-if="idlResume.IP.HasIP">
        <tr v-for="(ip, index) in idlResume.IP.Details" :key="index">
          <td>{{ ip.IPCode }}</td>
          <td>{{ ip.IPCategory }}</td>
          <td>
            <div style="word-break: break-all;">
              {{ ip.Description }}
            </div>
          </td>
        </tr>
      </template>
      <template v-else-if="idlResume.IP.HasIP === null">
        <tr>
          <td colspan="3">應聘者尚未填寫</td>
        </tr>
      </template>
      <template v-else>
        <tr>
          <td colspan="3">尚未擁有智財</td>
        </tr>
      </template>
    </table>

    七、專業技能及認證
    <table>
      <tr>
        <th id="skill">電腦技能</th>
        <td>
          {{ idlResume.Skill.ComputerSkill ? idlResume.Skill.ComputerSkill : "無" }}
        </td>
      </tr>

      <tr>
        <td>培訓紀錄</td>
        <td>
          {{ idlResume.Skill.TrainingRecord ? idlResume.Skill.TrainingRecord : "無" }}
        </td>
      </tr>
      <tr>
        <td>證照檢定</td>
        <td>{{ idlResume.Skill.Certificate ? idlResume.Skill.Certificate : "無" }}</td>
      </tr>
      <tr>
        <td>論文(題目)</td>
        <td>{{ idlResume.Skill.PaperTheme ? idlResume.Skill.PaperTheme : "無" }}</td>
      </tr>
      <tr>
        <td>論文(摘要)</td>
        <td>{{ idlResume.Skill.PaperSummary ? idlResume.Skill.PaperSummary : "無" }}</td>
      </tr>
      <tr>
        <td>工作專長</td>
        <td>{{ idlResume.Skill.Specialty ? idlResume.Skill.Specialty : "無" }}</td>
      </tr>
    </table>

    八、活動經驗
    <table>
      <tr>
        <th id="activity">社團/興趣</th>
        <td>
          {{
            idlResume.ActivityExperience.Interest
              ? idlResume.ActivityExperience.Interest
              : "無"
          }}
        </td>
      </tr>
      <tr>
        <td>優良事蹟</td>
        <td>
          {{
                idlResume.ActivityExperience.OutstandingPerformance
                  ? idlResume.ActivityExperience.OutstandingPerformance
                  : "無"
              }}
        </td>
      </tr>
      <tr>
        <td>挫折忍耐度</td>
        <td>
          {{
            idlResume.ActivityExperience.FrustrationTolerance
              ? idlResume.ActivityExperience.FrustrationTolerance
              : "無"
          }}

          具體實例:{{
            idlResume.ActivityExperience.ExtracurricularActivities
              ? idlResume.ActivityExperience.ExtracurricularActivities
              : "無"
          }}
        </td>
      </tr>
    </table>

    九、語言能力
    <table>
      <tr>
        <th id="language">種類</th>
        <td>語言檢定</td>
        <td>聽</td>
        <td>說</td>
        <td>讀</td>
        <td>寫</td>
      </tr>
      <template v-if="idlResume.Languages && idlResume.Languages.length>0">
      <tr v-for="(language, index) in idlResume.Languages" :key="index">
        <td>
          {{
            language.LanguageGuid === "11111111-1111-1111-1111-111111111111"
              ? language.LanguageDescription
              : language.Language
          }}
        </td>
        <td>{{ language.LanguageTest ? language.LanguageTest : "無" }}</td>
        <td>
          {{ language.Listen ? language.Listen : "無" }}
        </td>
        <td>{{ language.Speak ? language.Speak : "無" }}</td>
        <td>{{ language.Read ? language.Read : "無" }}</td>
        <td>{{ language.Write ? language.Write : "無" }}</td>
      </tr>
    </template>
    <template v-else>
      <tr>
      <td colspan="6">無</td>
      </tr>
    </template>
    </table>

    十、工作配合
    <table>
      <tr>
        <th id="work">未來輪班配合</th>
        <td>
          <template v-if="typeof idlResume.WorkCooperation.CanShiftWork === 'boolean'">
            {{ idlResume.WorkCooperation.CanShiftWork ? "是" : "否" }}
          </template>
          <template v-else>無</template>
          <template v-if="idlResume.WorkCooperation.CanShiftWorkDesc">
            <br />
            說明：{{ idlResume.WorkCooperation.CanShiftWorkDesc }}
          </template>
        </td>
        <td>未來出差/派駐配合</td>
        <td>
          <template v-if="idlResume.WorkCooperation.CanOfficeTripOrStation === null">
            無
          </template>
          <template v-else>
            {{ idlResume.WorkCooperation.CanOfficeTripOrStation }}
          </template>
          <template v-if="idlResume.WorkCooperation.CanOfficeTripOrStationDesc">
            <br />
            說明：{{ idlResume.WorkCooperation.CanOfficeTripOrStationDesc }}
          </template>
        </td>
      </tr>
      <tr>
        <td colspan="2">
          是否有任何個人、家庭因素會影響工作配合度、工作時間、需常請假等等事項
        </td>
        <td colspan="2">
          <template
            v-if="typeof idlResume.WorkCooperation.HasLackOfWorkCooperation === 'boolean'"
          >
            {{ idlResume.WorkCooperation.HasLackOfWorkCooperation ? "是" : "否" }}
          </template>
          <template v-else>無</template>
          <template v-if="idlResume.WorkCooperation.HasLackOfWorkCooperationDesc">
            <br />
            說明：{{ idlResume.WorkCooperation.HasLackOfWorkCooperationDesc }}
          </template>
        </td>
      </tr>
    </table>

    十一、請列出最近參加面試的工作職缺情況:
    <table>
      <tr>
        <th id="company">公司名稱</th>
        <td>產業</td>
        <td>地點</td>
        <td>面試日期</td>
        <td>應徵職務</td>
        <td>面試結果</td>
        <td>薪資</td>
      </tr>
      <template v-if="idlResume.InterviewInfos && idlResume.InterviewInfos.length>0">
        <tr v-for="(info, index) in idlResume.InterviewInfos" :key="index">
        <td>{{ info.Company }}</td>
        <td>{{ info.IndustryCategory }}</td>
        <td>{{ info.County }}/{{ info.District }}</td>
        <td>{{ $common.dateFormatter(info.InterviewDate) }}</td>
        <td>{{ info.Position }}</td>
        <td>{{ info.InterviewResult }}</td>
        <td>{{ info.BasicSalary }}</td>
      </tr>
      </template>
      <template v-else>
        <tr>
          <td colspan="7">無</td>
        </tr>
      </template>

      
    </table>

    十二、請選擇您應徵此工作職缺的需求：《請依重要性，排序第1~第10順位》
    <template v-if="idlResume.WorkConsiderations.length === 0"> 
      無<br><br>
    </template>
    <table v-else>
      <tr>
        <th id="seq">順序</th>
        <td v-for="(element, index) in idlResume.WorkConsiderations" :key="index">
          {{ ++index }}
        </td>
      </tr>
      <tr>
        <td>項目</td>
        <td v-for="(element, index) in idlResume.WorkConsiderations" :key="index">
          {{ element.Item }}
        </td>
      </tr>
      <tr>
        <td>原因</td>
        <td v-for="(element, index) in idlResume.WorkConsiderations" :key="index">
          {{ element.Reason }}
        </td>
      </tr>
    </table>

    十三、自傳
    <table>
      <tr>
        <th id="autobiography">
          <span
            v-if="idlResume.Autobiography.Autobiography"
            v-html="idlResume.Autobiography.Autobiography"
          />
          <span v-else>無</span>
        </th>
      </tr>
    </table>

    <div class="border">
      【聲明事項】<br />
      1.
      本人已詳閱並瞭解
      貴公司依個人資料保護法及相關法令之規定所告知本履歷表內個人資料之蒐集目的、利用之期間、
      地區、對象及方式、依個人資料保護法第三條規定得行使之權利及權利行使方式以及不提供本履歷表內個人資料時將對
      本人權益之影響，本人於茲表示同意
      貴公司依據告知內容蒐集、處理及利用本人之個人資料。
      <br />
      2.
      本人聲明並擔保於本履歷表內所提供第三人之個人資料，業獲該等人員同意提供其個人資料並允許相關之蒐集、處理
      及利用，如有爭議發生，悉由本人負相關法律責任，並賠償 貴公司因此所受之損害。
      <br />
      3.
      本人確認於本履歷表內填載之各項資料與陳述均屬實，並同意
      貴公司就本履歷表內所提供資料內容之正確性進行查證，如有虛偽不實之情事，本人願無條件接受
      貴公司解僱處分，如涉及違法，全憑 貴公司依法處理。
      <br />
      4.
      本人聲明並擔保本人至
      貴公司應徵未違反本人與現任雇主、前雇主或其他第三人之兼職禁止、競業禁止、利益衝突禁
      止、保密協議、智慧財產權協議或其他類似之約定，前開狀態若於接獲錄取通知至
      貴公司報到前有所變動，本人將主動告知並提供
      貴公司所需資訊。本人並承諾確實遵守智慧財產權相關法律及本人應履行之保密或智慧財產權相關約定，應
      徵期間所有之行為，絕不洩漏或侵害現任雇主、前雇主或其他第三人之營業秘密、機密資訊或其他智慧財產權。如有違
      反本條，悉由本人負相關法律責任，並賠償 貴公司因此所受之損害。
      <br />
      5.
      本人同意如因本人未提供正確個人資料導致權益受影響或遭遇緊急事件時無法獲得迅速妥善之處理，相關後果與責任
      悉由本人自行承擔。
      <br />
      6.
      本人同意如此次未獲 貴公司錄用或個人放棄報到，
      貴公司得保留本人資料並列入儲備人員，日後若有適當職缺時得再行通知本人。
      <br />
      7.
      本人已詳閱「妊娠與分娩後女性及未滿十八歲勞工禁止從事危險性或有害性工作」之相關規定。<br />
      <div style="text-align: right">
        簽名：___________________ 民國____年____月____日
      </div>
    </div>
    <br />
  </div>
</template>

<script>
export default {
  name: "IdlResume",
  props: ["ResumeId", "ResumeType"],
  data() {
    return {
      activeName: "個人資料",
      name: null,
      idlResume: [],

      headPhotoBase64: null,

      idlMenu: ["個人資料", "保密義務", "禁止條款", "智財", "自傳"],

      normalColor: "#fff0d2",
      selectedColor: "#ffe2a5",
    };
  },
  computed: {
    totalSeniority() {
      let total = this.idlResume.WorkExperiences.WorkExperiences.reduce((total, person) => total + person.Seniority, 0);
      return parseFloat(total.toFixed(1)); // 限制小數點後一位，並轉回數字
    }
  },

  methods: {
    // 取得 履歷
    async getResume() {
      this.$store.dispatch("updateLoading", true);
      await this.$api.viewResume.getResume(this.ResumeId).then((response) => {
        if (response.status === 200) {
          this.name = response.data.Name;
          this.headPhotoBase64 = response.data.HeadPhotoBase64;
          this.idlResume = response.data.IDLResume;
        }
        this.$store.dispatch("updateLoading", false);
      });
    },
  },

  created() {
    this.getResume();
  },
};
</script>

<style lang="scss" scoped>
/deep/ .el-tag--mini {
  margin-left: -2px;
  margin-bottom: 2px;
}

.center-text {
  text-align: center;
}

.width-5 {
  width: 5%;
}
.width-10 {
  width: 10%;
}
.width-15 {
  width: 15%;
}
.width-60 {
  width: 60%;
}

.experience-table {
  word-wrap: break-word;
  word-break: break-all;
}

.custom-resume-body {
  .border {
    border: 2px solid #000 !important;
    margin-bottom: 20px;
    .border-bottom {
      border-bottom: 1px solid #000 !important;
    }
  }

  table {
    border: 2px solid #000;
    width: 100%;
    margin-bottom: 20px;
    td {
      white-space: normal;
      border: 1px solid #000;
    }
    .work-content-wrap {
      // 強制切斷長單字 (如網址或亂碼)，否則會撐開
      word-break: break-all;
      // 處理長單字換行
      white-space: pre-wrap;
      box-sizing: border-box;
    }
  }
}
</style>
